import s from "./PersonDataConsentPage.module.scss";

export const PersonDataConsentPage = () => {
  return (
    <>
      <div className={s.personDataConsent}>
        <h2 className={s.personDataConsent_title}>Согласие</h2>
        <p className={s.personDataConsent_text}>
          Я согласен (а) на обработку моих персональных данных: фамилия, имя,
          отчество; дата рождения; контактный телефон.
        </p>
      </div>
    </>
  );
};
